var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2653",
    "data-name": "Group 2653",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.299,
    height: 16.159,
    viewBox: "0 0 25.299 16.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 25.299,
    height: 16.159,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2652",
    "data-name": "Group 2652",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M0,7.787A21.981,21.981,0,0,1,6.656,1.742,12.277,12.277,0,0,1,11.32.084a10.483,10.483,0,0,1,4.9.548,16.588,16.588,0,0,1,4.622,2.606,23.877,23.877,0,0,1,4.193,4.2,1.041,1.041,0,0,1,.261.574,1,1,0,0,1-.245.7A24.276,24.276,0,0,1,21.8,12.146a18.35,18.35,0,0,1-4.659,3.025,11.184,11.184,0,0,1-4.172.982,11.371,11.371,0,0,1-5.657-1.381A21.767,21.767,0,0,1,.668,9.264,8.944,8.944,0,0,1,0,8.38ZM12.633,14.44a7.18,7.18,0,0,0,1.447-.129,12.4,12.4,0,0,0,4.781-2.082,22.556,22.556,0,0,0,4.353-3.992.192.192,0,0,0,0-.307c-.406-.476-.833-.933-1.272-1.378a18.268,18.268,0,0,0-5.155-3.806,9.67,9.67,0,0,0-4.057-1.016,9.407,9.407,0,0,0-4.074.938,19.754,19.754,0,0,0-6.633,5.31c-.081.094-.051.152.017.231a20.787,20.787,0,0,0,5.843,4.909,10.1,10.1,0,0,0,4.749,1.323",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M128.139,49.228a5.022,5.022,0,0,1,5.031,5.029,5.026,5.026,0,1,1-5.031-5.029m.007,1.745a3.294,3.294,0,1,0,3.291,3.291,3.284,3.284,0,0,0-3.291-3.291",
    transform: "translate(-115.505 -46.184)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon_view.93b5bbe348fdf4c7163d66975e44f6d3.svg";
export { ForwardRef as ReactComponent };